import * as React from "react";
import { BarChart, Box, Container } from "@amzn/awsui-components-react-v3";
import { Delivery } from "../common/GetDeliveriesDetailsGQLResponse";
import { useEffect, useState } from "react";
import { CABLING_MANIFEST_BAR_CHART_CONSTANT, CABLING_STATUS_ENUM } from "../LmdpConstants";

interface DataPoint {
    x: Date;
    y: number;
}

interface CablingManifestRackGroupProps {
    items: Delivery[],
    isLoading: boolean;
}

interface DeliveryData {
    ML?: number;
    NON_ML?: number;
}

export default (props: CablingManifestRackGroupProps) => {
    
    const [mlChartData, setMlChartData] = useState<DataPoint[]>([]);
    const [nonMlChartData, setNonMlChartData] = useState<DataPoint[]>([]);

    useEffect(() => {
        const rackGroupDayWiseMap = new Map<string, DeliveryData>();
        props.items?.forEach(item => {
            const targetDeliveryDate = item.referenceIds.find(referenceId => referenceId.idType === "tdd")?.id;
            if (targetDeliveryDate && item.cablingStatus !== CABLING_STATUS_ENUM.CABLED && item.cablingStatus !== CABLING_STATUS_ENUM.IN_PROGRESS) {
                const currentValue = rackGroupDayWiseMap.get(targetDeliveryDate) ?? { ML: 0, NON_ML: 0 };
                const type = item.rackGroup === "ML" ? "ML" : "NON_ML";
                rackGroupDayWiseMap.set(targetDeliveryDate, { ...currentValue, [type]: (currentValue[type] ?? 0) + 1 });
            }
        });
        const mlData: DataPoint[] = [];
        const nonMlData: DataPoint[] = [];
        rackGroupDayWiseMap.forEach((value, key) => {
            const date = new Date(key);
            mlData.push({ x: date, y: value.ML ?? 0 });
            nonMlData.push({ x: date, y: value.NON_ML ?? 0 });
        });
        mlData.sort((a, b) => a.x.getTime() - b.x.getTime());
        nonMlData.sort((a, b) => a.x.getTime() - b.x.getTime());
        setMlChartData(mlData);
        setNonMlChartData(nonMlData);
    }, [props]);

  return (
    <Container>
        <h1> {CABLING_MANIFEST_BAR_CHART_CONSTANT.CHART_HEADER} </h1>
        <p> {CABLING_MANIFEST_BAR_CHART_CONSTANT.CHART_DESCRIPTION} </p>
            <BarChart
                series = { mlChartData.length === 0 && nonMlChartData.length === 0 ? []: [
                    {
                        title: "ML",
                        type: "bar",
                        data: mlChartData
                    },
                    {
                        title: "Non-ML",
                        type: "bar",
                        data: nonMlChartData
                    },
                ]}
                yDomain={[0, 100]}
                i18nStrings={{
                    xTickFormatter: e => {
                        const date = new Date(e);
                        const formattedDate = date.toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit"
                        });
                        return formattedDate;
                    }
                }}
                ariaLabel = {CABLING_MANIFEST_BAR_CHART_CONSTANT.CHART_ARIALABEL}
                height = {300}
                xTitle = {CABLING_MANIFEST_BAR_CHART_CONSTANT.X_AXIS_TITLE}
                yTitle = {CABLING_MANIFEST_BAR_CHART_CONSTANT.Y_AXIS_TITLE}
                hideFilter
                statusType = {props.isLoading ? "loading" : "finished"}
                empty={
                    <Box textAlign = "center" color = "inherit">
                    <b> {CABLING_MANIFEST_BAR_CHART_CONSTANT.NO_DATA_TITLE} </b>
                        <Box variant="p" color="inherit">
                            {CABLING_MANIFEST_BAR_CHART_CONSTANT.NO_DATA_DESCRIPTION}
                        </Box>
                    </Box>
                }
            />
    </Container>
  );
}